/* istanbul ignore file */
const loadImageObject = async imageUrl => new Promise(resolve => {
  const image = new Image();

  image.onload = () => {
    resolve(image);
  };

  image.src = imageUrl;
});

export default loadImageObject;
